import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import App from './App';



ReactDOM.render(<App />, document.getElementById('root'));